/* eslint-disable react/jsx-no-useless-fragment */

const Dummy = (): JSX.Element => <></>;

export default Dummy;
